import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';
import { EmployeeRoutes } from '../../api/routes/api-employee-routes';

export const updateEmployee = (employeeId: number, update: Partial<EmployeeUpdateRequest>) =>
  createGenericDispatcher<Employee>({
    name: 'UPDATE_EMPLOYEE',
    loadFunction: () =>
      Api.post(`${EmployeeRoutes.getBaseRoute(employeeId)}${EmployeeRoutes.EMPLOYEE}`, {
        body: JSON.stringify({
          update,
        }),
      }),
    args: { employeeId },
  });
